const NavBarData = {
  navItems: [
    {
      id: 0,
      fileId: 0,
      navbar_item: "Home",
      comment:
        "// Enter the following image file to implement the house icon: house",
      userInput: "",
      validate_expression: `house`,
      correct_expression: "house",
    },
    {
      id: 1,
      fileId: 0,
      navbar_item: "Careers",
      comment:
        "// Enter the following image file to implement the briefcase icon: briefcase",
      userInput: "",
      validate_expression: `briefcase`,
      correct_expression: "briefcase",
    },
    {
      id: 2,
      fileId: 0,
      navbar_item: "Education",
      comment:
        "// Enter the following image file to implement the graduation cap icon: grad_cap",
      userInput: "",
      validate_expression: `grad_cap`,
      correct_expression: "grad_cap",
    },
    {
      id: 3,
      fileId: 0,
      navbar_item: "Contact",
      comment:
        "// Enter the following image file to implement the phone icon: phone",
      userInput: "",
      validate_expression: `phone`,
      correct_expression: "phone",
    },
  ],
};
export default NavBarData;
